import { publishPermissionDenied } from "../auth/authStatus.js";
import { getAccessToken } from "../auth/keycloakAuth.js";

const ADMIN_REDIRECT_PATH = "/home/portfolios";

function publishAdminAccessDenied(status, to) {
    publishPermissionDenied({
        status,
        url: new URL(to.fullPath || to.path, window.location.origin).toString(),
        title: "Admin area only",
        message: "Only admin accounts can access this page. You can continue from your portfolios.",
        primaryLabel: "Back to portfolios",
        primaryAction: "goToRedirectUri",
        redirectUri: `${window.location.origin}${ADMIN_REDIRECT_PATH}`,
        secondaryLabel: "Use another account",
        secondaryAction: "retryLogout",
    });
}

export function routeRequiresAdmin(to) {
    return (to.path === "/admin" || to.path.startsWith("/admin/"))
        || Boolean(to.matched?.some((record) => record.meta?.requiresAdmin));
}

async function fetchAdminAccess() {
    const token = await getAccessToken();

    if (!token) {
        return { allowed: false, status: 401 };
    }

    const response = await fetch("/api/users/me", {
        credentials: "include",
        cache: "no-store",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        return { allowed: false, status: response.status };
    }

    const data = await response.json().catch(() => ({}));
    const allowed = Boolean(data?.isAdmin);

    return {
        allowed,
        status: allowed ? response.status : 403,
    };
}

export async function requireAdminAccess(to, next) {
    if (!routeRequiresAdmin(to)) {
        return next();
    }

    try {
        const access = await fetchAdminAccess();

        if (access.allowed) {
            return next();
        }

        publishAdminAccessDenied(access.status || 403, to);
    } catch (error) {
        console.warn("Admin route access check failed", error);
        publishAdminAccessDenied(403, to);
    }

    return next({ path: ADMIN_REDIRECT_PATH, replace: true });
}
